import React from 'react';
import { Nav } from 'react-bootstrap';
import { CATEGORY_LABELS } from '../../utils/constants';

interface CategoryButtonProps {
  label: string;
  handleClick: (label: string) => void;
}

const CategoryButton: React.FC<CategoryButtonProps> = ({ label, handleClick }) => {
  

  return (
    <Nav.Item>
      <Nav.Link
        eventKey={label}
        onClick={() => {
          handleClick(label);
        }}
      >
        {CATEGORY_LABELS[label as keyof typeof CATEGORY_LABELS]}
      </Nav.Link>
    </Nav.Item>
  );
};

export default CategoryButton;
